<template>
<div class="chapter">
<div class="inner_page">
<p><a id="p01"></a></p>
<div class="ct"><b>Part One</b></div>
<div class="cst"><b>Implementing Projects in the Math Class</b></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// musc_9781118040942_oeb_p01_r1.vue?57e3f5fa